import React, {Component} from 'react';
import {observer} from "mobx-react";
import AutosizeInput from 'react-input-autosize';
import Tooltip from "../../Helpers/Tooltip";

class Integer extends Component {
  constructor(props) {
    super(props);
    this.state={
      show_tooltip:false
    };
  }
  render() {
    if(this.props.locked) {
      return this.props.item.value;
    }
    return (
      <div>
        <Tooltip show={this.state.show_tooltip} text="Допускается ввод промежутков, например: 100-150">
          <AutosizeInput
            onFocus={()=>{ this.setState({ show_tooltip:true }); }}
            onBlur={()=>{ this.setState({ show_tooltip:false }); }}
            inputRef={(ref) => {
              this.props.inputRef(ref);
            }}
            onKeyDown={(e) => {
              this.props.onKeyDown(e);
            }}
            type="text"
            inputClassName="small"
            placeholder={"Поиск"}
            value={this.props.item.value}
            onChange={(e) => {
              const arg=e.target.value.matchAll(/([<>=!~]?[><=]?)([0-9]+)/gi).next();
              if(arg.value) {
                if(arg.value[2]) {
                  if(arg.value[1] === '~' ||arg.value[1] === '=' || arg.value[1] === '!=' || arg.value[1] === '>' || arg.value[1] === '<' || arg.value[1] === '>=' || arg.value[1] === '<=') {
                    this.props.item.compare=arg.value[1];
                    e.target.value=arg.value[2];
                  }
                }
              }
              this.props.item.value = e.target.value.replace(/[^\>\<\=\!\~\d.-]/g, '');
            }}
          />
        </Tooltip>
      </div>
    )
  }
}

export default observer(Integer);